import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { LandingpageConfiguration } from '../models/landingpage-configuration.model';
import { BackendErrorType } from '../services/errors/backend.errors';
import { BackendService } from '../services/backend.service';
import { LandingpageConfigurationStateService } from '../services/state/landingpage-configuration-state.service';
import { CorporateDesignService } from '../services/corporate-design.service';

@Injectable({
  providedIn: 'root',
})
/***
 routes either to OverviewComponent, Error page or AccessToken Component, dependig on the validity of the token passed in the url
 ***/
export class CheckForTokenGuard implements CanActivate {
  private backendService = inject(BackendService);
  private router = inject(Router);
  private logger = inject(NGXLogger);
  private landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);
  private titleService = inject(Title);
  private corporateDesignService = inject(CorporateDesignService);

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> | UrlTree {
    if (!route.queryParamMap.has('code')) {
      return this.router.parseUrl('/');
    }
    const token = route.queryParamMap.get('code')!;
    return this.isTokenValid(token);
  }

  isTokenValid(token: string): Observable<UrlTree> {
    return new Observable<UrlTree>((observer) => {
      this.backendService.submitPersonalAccessToken(token).subscribe({
        next: (response: LandingpageConfiguration) => {
          this.logger.debug('Request Landingpage Configuration:', {
            requestParam: token,
            response: response,
          });
          this.landingpageConfigurationStateService.updateConfig(response, token);

          //add orga specific colors, (fav)icons and fonts
          this.corporateDesignService.updateTheme(response.organisation.corporateDesign, response.assetBucketUrl);

          // Reset title
          this.titleService.setTitle('Ihre Zuzahlung');
          observer.next(this.router.parseUrl('/case'));
        },
        error: (error: Error) => {
          if (error.message === BackendErrorType.ALREADY_SENT) {
            observer.next(this.router.parseUrl('already-sent'));
          } else if (error.message === BackendErrorType.VERIFICATION_ERROR) {
            observer.next(this.router.parseUrl('verification-error'));
          } else {
            observer.next(this.router.parseUrl('/'));
          }
        },
      });
    });
  }
}
